<!-- eslint-disable vue/valid-v-bind -->
<!-- eslint-disable vue/no-parsing-error -->
<template>
  <!-- <div> -->
  <div>
    <v-overlay :z-index="2100" :value="loadingData">
      <img
        width="100"
        :src="require('@/assets/img/magnifier-zoom-search.gif')"
      />
      <div class="overlay-dowload">กำลังอัปโหลดข้อมูล...</div>
    </v-overlay>
    <v-dialog v-model="shower" width="1000px" position="top" :z-index="2000">
      <v-card flat>
        <v-card-title class="pa-3">
          <div>รายชื่อสำหรับส่งความยินยอม</div>
          <v-spacer></v-spacer>
          <v-btn outlined color="error" @click="Fn_Close()"> ปิด</v-btn>
        </v-card-title>
        <v-card-text>
          <v-layout row mt-2 mb-5>
            <v-flex>
              <v-card class="rounded-lg pb-2" outlined>
                <v-tabs v-model="tab" align-with-title color="#077893">
                  <v-tabs-slider color="#077893"></v-tabs-slider>
                  <v-tab v-for="item in items" :key="item">
                    {{ $t(item) }}
                  </v-tab>
                </v-tabs>
                <v-tabs-items v-model="tab">
                  <v-tab-item>
                    <v-layout row wrap justify-start mt-4 mb-5 ml-10>
                      <v-flex xs11 sm7 md3 lg3>
                        <v-text-field
                          hide-details
                          dense
                          outlined
                          :label="$t('NewUpdate.employeecode')"
                          color="#077893"
                          v-model="NumId"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs11 sm3 md2 lg2 pl-3>
                        <v-btn
                          dark
                          color="#077893"
                          :loading="loadingSearch"
                          @click="Fn_GetEmployeeId"
                          >{{ $t("consentlist.search") }}</v-btn
                        >
                      </v-flex>
                    </v-layout>
                  </v-tab-item>
                  <v-tab-item>
                    <v-card class="rounded-lg">
                      <v-card-text>
                        <v-layout row wrap justify-center align-center>
                          <v-flex
                            xs12
                            sm12
                            md12
                            lg12
                            pr-2
                            justify-end
                            text-right
                            mt-5
                          >
                            <v-btn
                              dense
                              dark
                              color="#077893"
                              @click="dowloadExcel"
                              :loading="loadingDownloadCSV"
                              class="ma-1"
                              >{{ $t("email.text2") }}</v-btn
                            >
                          </v-flex>
                          <v-flex xs12 lg12 pa-2>
                            <div v-if="file == ''">
                              <div
                                :class="[
                                  'dropZone',
                                  dragging ? 'dropZone-over' : '',
                                ]"
                                @dragenter="dragging = true"
                                @dragleave="dragging = false"
                              >
                                <div class="dropZone-info" @drag="Fn_OnChange">
                                  <span class="dropZone-title">
                                    <h3>
                                      <v-icon size="38" color="#077893"
                                        >mdi-inbox-arrow-down-outline</v-icon
                                      >
                                    </h3>
                                  </span>
                                  <div class="dropZone-upload-limit-info">
                                    <div>
                                      {{ $t("oneAccount.text3") }}
                                    </div>
                                    <div>{{ $t("oneAccount.text5") }}</div>
                                    <div class="red--text pt-4">
                                      <b> ***</b> {{ $t("oneAccount.Note") }}
                                    </div>
                                  </div>
                                </div>
                                <input
                                  accept=".xls,.xlsx"
                                  multiple
                                  type="file"
                                  @change="Fn_OnChange"
                                />
                              </div>
                            </div>
                            <v-card outlined v-else>
                              <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                  :disabled="isHandleFile"
                                  depressed
                                  :dark="!isHandleFile"
                                  color="#077893"
                                  :loading="LoadingUpload"
                                  @click="Fn_SubmitFile"
                                  ><v-icon class="mr-1"
                                    >mdi-tray-arrow-up</v-icon
                                  >
                                  อัปโหลด</v-btn
                                >
                                <v-btn color="error" @click="Fn_RemoveFile">
                                  <v-icon>mdi-trash-can-outline</v-icon>
                                  เคลียร์ข้อมูล</v-btn
                                >
                              </v-card-actions>
                              <v-card-text>
                                <center>
                                  <img
                                    height="100"
                                    width="100"
                                    :src="require('@/assets/img/excel.png')"
                                  />
                                  <p>{{ file.name }}</p>
                                </center>
                                <v-layout row wrap justify-center align-center>
                                  <v-flex
                                    v-if="showeProgress"
                                    lg12
                                    sm12
                                    md12
                                    class="text-end"
                                  >
                                    <span class="blue--text"
                                      ><b>{{ value }} %</b></span
                                    >
                                  </v-flex>
                                </v-layout>
                                <div style="min-height: 4px">
                                  <v-progress-linear
                                    v-if="showeProgress"
                                    v-model="value"
                                    color="#077893"
                                    :active="show"
                                    :indeterminate="query"
                                    :query="true"
                                    class="mt-2"
                                  />
                                </div>
                              </v-card-text>
                            </v-card>
                          </v-flex>
                        </v-layout>
                      </v-card-text>
                    </v-card>
                  </v-tab-item>
                </v-tabs-items>
              </v-card>
            </v-flex>
          </v-layout>
          <v-layout
            row
            mt-2
            mb-5
            class="fade-transition"
            v-if="uploadSuccessList.length > 0 || uploadErrorList.length > 0"
          >
            <v-flex>
              <v-card class="rounded-lg pb-2" outlined>
                <v-tabs v-model="tableTab" align-with-title color="#077893">
                  <v-tabs-slider color="#077893"></v-tabs-slider>
                  <v-tab v-for="item in tableItems" :key="item">
                    <v-badge
                      :color="item == 'รายการที่พบข้อมูล' ? 'green' : 'error'"
                      :content="
                        item === 'รายการที่พบข้อมูล'
                          ? uploadSuccessCount
                          : uploadErrorCount
                      "
                    >
                      {{ $t(item) }}
                    </v-badge>
                  </v-tab>
                </v-tabs>
                <v-tabs-items v-model="tableTab">
                  <v-tab-item>
                    <v-card class="rounded-lg">
                      <v-card-text>
                        <v-layout row wrap justify-start align-center ml-7 mr-7>
                          <v-flex d-flex pa-2 md4 lg4>
                            <v-text-field
                              clearable
                              outlined
                              dense
                              height="40px"
                              v-model="Search"
                              append-icon="mdi-magnify"
                              :label="$t('consentlist.searchname')"
                              color="#077893"
                              hide-details
                            ></v-text-field>
                          </v-flex>
                          <v-spacer></v-spacer>
                          <v-flex justify-end d-flex pa-2 md8 lg8>
                            <v-btn
                              class="mr-1"
                              rounded
                              outlined
                              color="error"
                              :loading="loadingCancel"
                              @click="Fn_ClearEmpployeeList"
                              >ยกเลิก</v-btn
                            >
                            <v-btn
                              dark
                              rounded
                              color="#077893"
                              :loading="loadingSave"
                              @click="Fn_Save(uploadSuccessList)"
                              >{{ $t("email.text7") }}</v-btn
                            >
                          </v-flex>
                        </v-layout>
                        <v-layout row wrap justify-center align-center>
                          <v-flex xs11 sm11 md11 lg11 pa-2>
                            <v-data-table
                              :search="Search"
                              :headers="header"
                              :items="uploadSuccessList"
                              class="elevation-1"
                              :loading="loadingSearch"
                              :footer-props="{
                                'items-per-page-options': [7, 10, 15, -1],
                              }"
                              :items-per-page="7"
                            >
                              <template v-slot:[`item.delete`]="{ item }">
                                <v-btn
                                  class="mx-2"
                                  icon
                                  dark
                                  color="error"
                                  @click="deleteItem(item)"
                                >
                                  <v-icon>mdi-trash-can</v-icon>
                                </v-btn>
                              </template>
                            </v-data-table>
                          </v-flex>
                        </v-layout>
                      </v-card-text>
                    </v-card>
                  </v-tab-item>
                  <v-tab-item>
                    <v-card class="rounded-lg">
                      <v-card-text>
                        <v-layout row wrap justify-start align-center ml-7 mr-7>
                          <v-flex justify-end d-flex lg12>
                            <v-btn
                              class="mr-1"
                              rounded
                              outlined
                              color="error"
                              :loading="loadingCancel"
                              @click="Fn_ClearEmpployeeErrorList"
                              >ล้าง</v-btn
                            >
                          </v-flex>
                        </v-layout>
                        <v-layout row wrap justify-center align-center>
                          <v-flex xs11 sm11 md11 lg11 pa-2>
                            <v-data-table
                              :headers="header2"
                              :items="uploadErrorList"
                              class="elevation-1"
                              :loading="loadingSearch"
                              :footer-props="{
                                'items-per-page-options': [7, 10, 15, -1],
                              }"
                              :items-per-page="7"
                            >
                              <template v-slot:[`item.delete`]="{ item }">
                                <v-btn
                                  class="mx-2"
                                  icon
                                  dark
                                  color="error"
                                  @click="deleteItemNotFoundList(item)"
                                >
                                  <v-icon>mdi-trash-can</v-icon>
                                </v-btn>
                              </template>
                            </v-data-table>
                          </v-flex>
                        </v-layout>
                      </v-card-text>
                    </v-card>
                  </v-tab-item>
                </v-tabs-items>
              </v-card>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>
    <DialogCheckUser
      :show="isDialogList"
      :_detail="ItemsCheckUser"
      :_payload="payloadUserOnechat"
      @closeDialogDelete="isDialogList = false"
    />
  </div>
  <!-- </div> -->
</template>

<script>
// import DialogCheckUser from "@/components/dialog/ConsentOnePlatform/DialogConsentCheckUserOnePlatform.vue";
import DialogCheckUser from "@/components/dialog/ConsentEmail/DialogConsentCheckUserEmail.vue";
import { mapGetters } from "vuex/dist/vuex.common.js";
import authorization from "@/functions/authorization.js";
import Swal2 from "sweetalert2/dist/sweetalert2.js";
const Toast = Swal2.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});
export default {
  components: { DialogCheckUser },
  props: ["show", "announce"],
  data: function () {
    return {
      tab: null,
      tableTab: null,
      dragging: false,
      loadingDownloadData: false,
      loadingData: false,
      showeProgress: false,
      LoadingUpload: false,
      loadingSearch: false,
      loadingDownloadCSV: false,
      loadingCancel: false,
      loadingSave: false,
      isDialogList: false,
      isHandleFile: false,
      query: false,
      Search: "",
      ItemsCheckUser: [],
      file: [],
      payloadUserOnechat: {},
      uploadSuccessList: [
        // {
        //   employeeId: "12345",
        //   fullName: "John Doe",
        //   delete: "delete",
        // },
        // {
        //   employeeId: "12345",
        //   fullName: "John Doe",
        //   delete: "delete",
        // },
        // {
        //   employeeId: "12345",
        //   fullName: "John Doe",
        //   delete: "delete",
        // },
        // {
        //   employeeId: "12345",
        //   fullName: "John Doe",
        //   delete: "delete",
        // },
        // {
        //   employeeId: "12345",
        //   fullName: "John Doe",
        //   delete: "delete",
        // },
      ],
      uploadErrorList: [
        // {
        //   employeeId: "67890",
        //   fullName: "Jane Smith",
        //   delete: "delete",
        // },
      ],
      value: 0,
      NumId: "",
      items: ["กรอกรหัสพนักงาน", "นำเข้าแบบฟอร์ม Excel"],
      tableItems: ["รายการที่พบข้อมูล", "รายการที่ไม่พบข้อมูล"],
      header: [
        {
          text: "ชื่อ-นามสกุล",
          value: "NameTh",
          align: "center",
          sortable: false,
        },
        { text: "ลบ", value: "delete", align: "center", sortable: false },
      ],
      header2: [
        {
          text: "รหัสพนักงาน",
          value: "EmployeeId",
          align: "center",
          sortable: false,
        },
        { text: "ลบ", value: "delete", align: "center", sortable: false },
      ],
      fileUrl: "/files/Template_Upload_EmpId.xlsx",
    };
  },
  computed: {
    ...mapGetters(["getOnePlatform"]),
    ...mapGetters(["DataGroupConsent"]),
    ...mapGetters(["DataGroupOneChatSearch"]),
    shower: {
      get() {
        return this.show;
      },
      set(value) {
        if (!value) {
          this.$emit("closeDialog");
        }
      },
    },
    _DataGroupOneChatSearch: {
      get() {
        return this.DataGroupOneChatSearch || "-";
      },
    },
    uploadSuccessCount() {
      return this.uploadSuccessList.length || "0";
    },
    uploadErrorCount() {
      return this.uploadErrorList.length || "0";
    },
  },
  watch: {
    show(newVal) {
      if (newVal) {
        this.uploadSuccessList = [];
        this.uploadErrorList = [];
        this.file = [];
        this.Search = "";
        this.NumId = "";
        this.isHandleFile = false;
      }
    },
  },
  methods: {
    Fn_Save(val) {
      this.loadingSave = true;
      if (this._DataGroupOneChatSearch.Consent === undefined) {
        this.$emit("closeDialog");
        this.$emit("confirmEmployee", val);
        this.loadingSave = false;
      } else if (this._DataGroupOneChatSearch.Consent.length > 0) {
        this.Fn_CheckUserOnechat();
      } else {
        this.loadingSave = false;
      }
      this.uploadSuccessList = [];
      this.uploadErrorList = [];
      this.file = [];
      this.Search = "";
      this.NumId = "";
    },
    async Fn_CheckUserOnechat() {
      this.uploadSuccessList = this.uploadSuccessList.map(
        ({ EmployeeId, ...res }) => res
      );
      if (this._DataGroupOneChatSearch.Type === "General") {
        this.SelectConsentGeneral =
          this._DataGroupOneChatSearch.Detail.Consent[0].ConsentId;
        this.SelectConsentGroup = "";
      } else if (this._DataGroupOneChatSearch.Type === "Group") {
        this.SelectConsentGeneral = "";
        this.SelectConsentGroup =
          this._DataGroupOneChatSearch.Detail.Consent[0].GroupId;
      }
      this.payloadUserOnechat = {
        UserName: this.$cookies.get("OneUsername"),
        BusinessId: this.$cookies.get("BusinessId"),
        AccountId: this.$cookies.get("OneAccountId"),
        Receiver: this.uploadSuccessList,
        GroupId: this.SelectConsentGroup, //
        ConsentId: this.SelectConsentGeneral,
        // Consent: this.SelectConsentGeneral,
        PolicyId: this._DataGroupOneChatSearch.Detail.Policy[0].PolicyId,
        UserId: this.$cookies.get("OneAccountId"),
        GroupSend: this._DataGroupOneChatSearch.Detail.GroupSend,
        ShowPolicy: true,
        TransactionId: this.$cookies.get("TransactionIdEmail").TransactionId, //
        TemplateEmail: this.$cookies.get("TransactionIdEmail").TemplateId, //
      };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE +
            "email/CheckUserEmailConsent",
          this.payloadUserOnechat
        )
        .then((response) => {
          this.LoadingSentConsent = false;
          this.loadingSave = false;
          if (response.data.Status === "OK") {
            this.ItemsCheckUser = response.data.Message;
            this.isDialogList = true;
            this.$emit("closeDialog");
            this.$store.dispatch("SET_DATA_CHECK_USER", this.ItemsCheckUser);
          } else {
            this.LoadingSentConsent = false;
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          this.LoadingSentConsent = false;
          this.loadingSave = false;
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    Fn_ClearEmpployeeList() {
      this.loadingCancel = true;
      this.uploadSuccessList = [];
      this.uploadErrorList = [];
      this.Search = "";
      this.NumId = "";
      this.loadingCancel = false;
    },
    Fn_ClearEmpployeeErrorList() {
      this.loadingCancel = true;
      this.uploadErrorList = [];
      this.loadingCancel = false;
    },
    Fn_CheckDupEmployeeList(ItemsEmployeeId) {
      if (this.uploadSuccessList.length > 0) {
        const existingIds = this.uploadSuccessList.map(
          (item) => item.AccountId
        );
        if (existingIds.includes(ItemsEmployeeId.AccountId)) {
          Toast.fire({
            icon: "error",
            title: `รหัสพนักงาน ${this.NumId} มีอยู่แล้วในรายการ`,
          });
          return false;
        }
      }
      return true;
    },
    async Fn_GetEmployeeId() {
      this.loadingSearch = true;
      var payload = {
        BusinessId: this.$cookies.get("BusinessId"),
        AccessToken: this.$cookies.get("OneAccessToken"),
        RoleAccount: this.$cookies.get("RoleAccountId"),
        EmployeeId: this.NumId,
      };
      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(payload);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE + "business/GetEmployee",
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          this.loadingSearch = false;
          if (response.data.Status === "OK") {
            const ItemsEmployeeId = response.data.Message;
            if (this.Fn_CheckDupEmployeeList(ItemsEmployeeId)) {
              // Handle duplicate employee IDs
              this.uploadSuccessList = [
                ...this.uploadSuccessList,
                ItemsEmployeeId,
              ];
            }
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          this.loadingSearch = false;
          if (error.response) {
            if (
              error.response.data.ErrorMessage ===
              "Warning.parameter EmployeeId is empty"
            ) {
              Toast.fire({
                icon: "error",
                title: "กรุณากรอกรหัสพนักงาน",
              });
            } else {
              Toast.fire({
                icon: "error",
                title: error.response.data.ErrorMessage,
              });
            }
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    async Fn_UploadExcelEmpIDList(file) {
      var formData = new FormData();
      formData.append("BusinessId", this.$cookies.get("BusinessId"));
      formData.append("AccessToken", this.$cookies.get("OneAccessToken"));
      formData.append("RoleAccount", this.$cookies.get("RoleAccountId"));
      formData.append("Template", file);
      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE +
            "business/GetEmployeesByExcel",
          formData,
          { headers }
        )
        .then((response) => {
          if (response.data.Status === "OK") {
            const newItems = response.data.Message.EmployeeList.filter(
              (newItem) =>
                !this.uploadSuccessList.some(
                  (oldItem) => oldItem.AccountId === newItem.AccountId
                )
            );
            this.uploadSuccessList = [...this.uploadSuccessList, ...newItems];

            this.uploadSuccessList = this.uploadSuccessList.map((item) => {
              const newItem = { ...item };
              delete newItem.EmployeeId;
              return newItem;
            });
            this.uploadErrorList = response.data.Message.EmployeeIdFailList;
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
          this.loadingData = false;
        })
        .catch((error) => {
          this.loadingData = false;
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    deleteItem(item) {
      const index = this.uploadSuccessList.indexOf(item);
      if (index > -1) {
        this.uploadSuccessList.splice(index, 1);
      }
    },
    deleteItemNotFoundList(item) {
      const index = this.uploadErrorList.indexOf(item);
      if (index > -1) {
        this.uploadErrorList.splice(index, 1);
      }
    },
    dowloadExcel() {
      this.loadingDownloadCSV = true;
      const link = document.createElement("a");
      link.href = this.fileUrl;
      link.download = "Template_Upload_EmpId.xlsx";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      this.loadingDownloadCSV = false;
    },
    Fn_Close() {
      this.uploadSuccessList = [];
      this.uploadErrorList = [];
      this.file = [];
      this.Search = "";
      this.NumId = "";
      this.isHandleFile = false;
      this.$emit("closeDialog");
    },
    Fn_OnChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) {
        this.dragging = false;
        return false;
      }

      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        const fileName = file.name.toLowerCase();
        const allowedExtensions = [".xls", ".xlsx"];
        const isValidFile = allowedExtensions.some((ext) =>
          fileName.endsWith(ext)
        );

        if (!isValidFile) {
          this.dragging = false;
          e.target.value = ""; // ล้างค่าอินพุตไฟล์
          return false;
        }
      }

      this.file = files[0];
    },
    Fn_RemoveFile() {
      this.isHandleFile = false;
      this.file = [];
    },
    Fn_CreateFile(file) {
      this.loadingDownloadData = true;
      if (
        !file.type.match(
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        )
      ) {
        this.dragging = false;
        this.loadingDownloadData = false;
      } else if (file.size > 5000000) {
        this.dragging = false;
        this.loadingDownloadData = false;
      } else if (this.file !== null) {
        this.file = file;
        this.dragging = false;
        this.loadingDownloadData = false;
      }
    },
    Fn_SubmitFile() {
      this.isHandleFile = true;
      this.loadingData = true;
      this.Fn_UploadExcelEmpIDList(this.file);
    },
  },
};
</script>

<style scoped>
.test {
  color: red;
}
.dropZone {
  width: 100%;
  height: 138px;
  position: relative;
  border: 2px dashed #eee;
  transition: 0.3s;
  border-radius: 0.5rem;
}

.dropZone:hover {
  border: 2px dashed #077893;
  opacity: 1;
  border-radius: 0.5rem;
  background-color: #00000021;
}

.dropZone:hover,
.dropZone-title:hover {
  color: #077893;
}

.dropZone-info {
  color: #a8a8a8;
  position: absolute;
  top: 50%;
  width: 100%;
  transform: translate(0, -50%);
  text-align: center;
}

.dropZone-title {
  color: #787878;
}

.dropZone input {
  position: absolute;
  cursor: pointer;
  top: 0px;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
}

.dropZone-upload-limit-info {
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
}

.dropZone-over {
  background: #5c5c5c;
  opacity: 0.8;
}

.fade-transition {
  transition: opacity 0.5s ease, transform 1s ease;
}

.overlay-dowload {
  font-weight: bolder;
  font-size: larger;
}
</style>
